import { ThemedDateRangeField } from "@vega-core/components/Form/Controls/DateField/ThemedDateRange";

import { DeviceLoginTable } from "../components/DeviceLoginTable";
import { SettingsSectionLayout } from "../components/SettingsSectionLayout";
import { useDeviceLoginData } from "../hooks/useDeviceLoginData";

export function LoginHistory() {
  const deviceLoginData = useDeviceLoginData();
  const { dateRange, handleDateRangeChange, isLoading } = deviceLoginData;

  return (
    <SettingsSectionLayout bordered>
      <div className="flex flex-col gap-y-4">
        <ThemedDateRangeField
          isLoading={isLoading}
          name="device-login-date-range"
          onChange={handleDateRangeChange}
          value={dateRange}
        />
        <DeviceLoginTable deviceLoginData={deviceLoginData} />
      </div>
    </SettingsSectionLayout>
  );
}
